<template>
  <v-container class="profile-view pl-0 pr-0" fill-height fluid>
    <v-layout fill-height fluid column space-between align-center>
      <BorderedTabs :settings="tabSettings"></BorderedTabs>
      <router-view :key="$route.path"></router-view>
    </v-layout>
  </v-container>
</template>

<script>
import BorderedTabs from '@/components/BorderedTabs'
import routes from '@/route_names'

export default {
  name: 'ProfileView',
  mixins: [
    {
      computed: {
        routes: function() {
          return routes
        }
      }
    }
  ],
  components: {
    BorderedTabs
  },
  created: function() {},
  data: function() {
    return {
      route: this.$router.currentRoute.name,
      loading: true,
      tabSettings: {
        preselected: null,
        tabs: [
          {
            id: routes.ACCOUNTS_PROFILE_DETAILS,
            label: 'User Details'
          },
          {
            id: routes.ACCOUNTS_PROFILE_CHANGE_PASSWORD,
            label: 'Change Password'
          }
        ]
      }
    }
  },
  methods: {
    save() {}
  }
}
</script>

<style lang="stylus">
</style>
